import { ElementParallaxItem, ParallaxController } from '@smoovy/parallax';
import { isMobile } from '../utils/useragent';

class Parallax {
  public smoovyController: ParallaxController;
  public parallaxItems: Array<ElementParallaxItem> = [];

  bindings() {
    window.addEventListener('scroll', () => {
      this.smoovyController.update({
        scrollPosX: window.scrollX,
        scrollPosY: window.scrollY,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        contentWidth: document.body.offsetWidth,
        contentHeight: document.body.offsetHeight
      });
    });

    // these selectors cause a change in document height and therefore break parallax elements, so we just reinitialize the parallax, amazing right?
    const parallaxChangingTriggerButtons = document.querySelectorAll('.o-two-column-hero .js-two-column-hero__button, .o-two-column-hero .js-two-column-hero__button-close');
    parallaxChangingTriggerButtons.forEach((button) => button.addEventListener('click', () => {
      setTimeout(() => {
        this.parallaxItems.forEach((item) => {
          this.smoovyController.remove(item);
        });

        // @ts-ignore
        document.querySelectorAll('[data-parallax]').forEach((element: HTMLElement) => {
          var item = new ElementParallaxItem(element, {
            speed: parseFloat(element.getAttribute('data-parallax') || '0')
          });
          this.smoovyController.add(item);
          this.parallaxItems.push(item);
        });
      }, 1000);
    }));

    // @ts-ignore
    document.querySelectorAll('[data-parallax]').forEach((element: HTMLElement) => {
      var item = new ElementParallaxItem(element, {
        speed: parseFloat(element.getAttribute('data-parallax') || '0')
      });
      this.smoovyController.add(item);
      this.parallaxItems.push(item);
    });

    // window.addEventListener('resize', () => {
    //   if (isMobile() || window.innerWidth < 1024) {
    //     this.parallaxItems.forEach((item) => {
    //       this.smoovyController.remove(item);
    //     });
    //   }
    // });
  }

  cache() {
    this.smoovyController = new ParallaxController();
  }

  init() {
    // if (isMobile() || window.innerWidth < 1024) {
    //   return false;
    // }

    this.cache();
    this.bindings();
  }
}

export default Parallax;
